export const IMPORT_PROFILE_STATUS_DESCRIPTION = {
    mapped: "import profile mapped description",
    warning: "import profile warning description",
    error: "import profile error description",
    skipped: "import profile skipped description",
    unmapped: "import profile not mapped description",
};

export const importProfileStatusDescriptionKey = (status) =>
    IMPORT_PROFILE_STATUS_DESCRIPTION[status] || IMPORT_PROFILE_STATUS_DESCRIPTION.unmapped;

export const importProfileStatusFromProfile = (profile) => {
    if (!profile) return "unmapped";
    if (profile.errorCount > 0) return "error";
    if (profile.warningCount > 0) return "warning";
    if (profile.mappedColumns === profile.totalColumns && profile.totalColumns > 0) return "mapped";
    return "unmapped";
};
